import React, { useState, useCallback } from 'react';

export  function useDialog() {
  const [openDialogs, setOpenDialogs] = useState({});

  const openDialog = useCallback((id) => {
    setOpenDialogs((prev) => ({ ...prev, [id]: true }));
  }, []);

  const closeDialog = useCallback((id) => {
    setOpenDialogs((prev) => ({ ...prev, [id]: false }));
  }, []);

  const isOpen = useCallback((id) => !!openDialogs[id], [openDialogs]);

  return {
    openDialog,
    closeDialog,
    isOpen,
  };
}
